import React from 'react';
import { Redirect } from 'react-router-dom';
import { shape } from 'prop-types';

const propTypes = {
  location: shape({}).isRequired,
};

const PageRedirect = ({ location }) => (
  <Redirect
    to={{
      ...location,
      pathname: '/',
    }}
  />
);

PageRedirect.propTypes = propTypes;

export default PageRedirect;
